<template>
  <div class="mobileLgWrap_he">
    <!-- <img class="userLoginTitle_he" src="../../../static/images/mobile/loginLogo.png" alt="" /> -->
    <div class="loginMain_he">
      <form>
        <van-cell-group>
          <van-field v-model="mobile"
                     name="mobile"
                     clearable
                     label-align="left"
                     placeholder="请输入手机号" />
          <van-field v-model="password"
                     name="password"
                     label-align="left"
                     placeholder="请输入密码"
                     :clearable="true"
                     :right-icon="rightIcon"
                     :type="pwdType"
                     @click-right-icon="changeType"
                     @input="changColor" />
          <p class="register_forget_he">
            <a href="javascript:;"
               class="fl"
               @click="goRegister">新用户注册</a>
            <a href="javascript:;"
               class="fr blue"
               @click="goForgetPassword">忘记密码?</a>
          </p>
          <div :class="passwordNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'"
               @click="login()">
            <span><a href="javascript:;">登录</a></span>
          </div>
          <div @click="passwordLogin"
               class="mobileLoginBtn-message">
            短信验证码登录
          </div>
        </van-cell-group>
      </form>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
const Base64 = require('js-base64').Base64
import Vue from 'vue'
import { Toast } from 'vant'
export default {
  data() {
    return {
      pwdType: 'password', // 密码类型
      rightIcon: 'closed-eye',
      number: '',
      password: '',
      passwordNum: '',
      loadingFlg: false,
      loginDisable: false,
      mobile: '',
      seen: '',
      platformId: '',
      remember: true,
      showMaintenance: 0,
      showRegist: 0,
      phoneNum: ''
    }
  },
  methods: {
    // 过滤密码空格
    formatter(value) {
      return value.replace(/\s+/g, '')
    },
    //短信验证登录
    passwordLogin() {
      this.$router.push({ path: '/mobileLoginYzm' })
    },
    // 切换按钮颜色
    changColor(e) {
      this.passwordNum = e.length
      pwdType: "password"; // 密码类型
      rightIcon: "closed-eye";
      number: "";
      password: "";
      passwordNum: "";
      loadingFlg: false;
      loginDisable: false;
      mobile: "";
      seen: "";
      platformId: "";
      remember: true;
      showMaintenance: 0;
      showRegist: 0;
      phoneNum: "";
    }
  },
  methods: {
    //短信验证登录
    passwordLogin() {
      this.$router.push({ path: "/mobileLoginYzm" });
    },
    // 切换按钮颜色
    changColor(e) {
      this.passwordNum = e.length;
    },
    /**
     * 登录函数
     */
    login() {
      // 先判断手机号是否为空 为空输入手机号

      if (this.mobile == "") {
        Toast("请先输入手机号");
      } else {
        if (!this.$util.isPhoneNumber(this.mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }
        if (this.password == "") {
          Toast("请先输入密码");
          return false;
        }
        let params = {};
        params.userName = this.mobile;
        params.password = md5(this.password);
        this.$api.get("/user/h5validateLogin", params, (res) => {
          if (res.status == 0) {
            localStorage.setItem("userId", res.data.userId);
            localStorage.setItem("mobile", this.mobile);
            localStorage.setItem("password", md5(this.password));
            if (res.data.option == "uploadIdCard") {
              localStorage.setItem("type", 1);
              this.$router.push({
                path: "/mobileAuthenticationFirst",
              });
            } else if (res.data.option == "faceCollect") {
              localStorage.setItem("type", 2);
              this.$router.push({
                path: "/mobileAuthenticationFirst",
              });
            } else if (res.data.option == "faceVerify") {
              localStorage.setItem("type", 3);
              this.$router.push({
                path: "/mobileFaceVerification",
              });
            } else if (res.data.option == "uploadIdCard faceVerify") {
              localStorage.setItem("type", 4);
              this.$router.push({
                path: "/mobileAuthenticationFirst",
              });
            } else if (res.data.option == "uploadIdCard faceCollect") {
              localStorage.setItem("type", 5);
              this.$router.push({
                path: "/mobileAuthenticationFirst",
              });
            } else if (res.data.option == "") {
              this.$axiosPackag.getMessageByAxios(
                "POST",
                "/user/h5login",
                { userName: this.mobile, password1: md5(this.password) },
                null,
                null,
                (resD) => {
                  if (resD) {
                    // this.setUserInfo(md5(this.password));
                    localStorage.setItem("loginUrl", resD);
                    Toast("登录成功");
                    this.$axiosPackag.getMessageByAxios(
                      "GET",
                      "/session/getSession",
                      null,
                      null,
                      null,
                      (resD) => {
                        if (resD) {
                          this.$sessionStore.initSession(resD);
                          this.$router.push({ path: "/mobileHome" });
                        }
                      }
                    );
                  }
                },
                (errorCall) => {}
              );
            }
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 隐藏显示密码
    changeType() {
      this.pwdType = this.pwdType === "password" ? "text" : "password";
      this.seen = !this.seen; //小眼睛的变化
      if (this.seen) {
        this.rightIcon = "eye-o";
      } else {
        this.rightIcon = "closed-eye";
      }
    },
    /**
     * 跳转到注册页面
     */
    goRegister() {
      this.$router.push({
        path: '/mobileRegister'
      })
    },
    /**
     * 跳转到忘记密码页面
     */
    goForgetPassword() {
      this.$router.push({
        path: '/mobileForgetPassword'
      })
    },
    /**
     * 储存表单信息
     */
    // setUserInfo: function (md5Password) {
    // 	// 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
    // 	// 如果没有勾选，储存的信息为空
    // 	if (this.remember) {
    // 		this.setCookie("mobile", this.mobile, 100000);
    // 		this.setCookie("password", md5Password, 100000);
    // 	} else {
    // 		this.setCookie("mobile", "");
    // 		this.setCookie("password", "");
    // 	}
    // },
    /**
     * 获取cookie
     * @param key cookie值
     */
    // getCookie: function (key) {
    // 	if (document.cookie.length > 0) {
    // 		var start = document.cookie.indexOf(key + "=");
    // 		if (start !== -1) {
    // 			start = start + key.length + 1;
    // 			var end = document.cookie.indexOf(";", start);
    // 			if (end === -1) end = document.cookie.length;
    // 			return unescape(document.cookie.substring(start, end));
    // 		}
    // 	}
    // 	return "";
    // },
    /**
     * 保存cookie
     * @param cName         cookie的键值
     * @param value         cookie值
     * @param expiredays    过期时间
     */
    setCookie: function (cName, value, expiredays) {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie =
        cName +
        '=' +
        escape(value) +
        (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
    }
  },
  created() {
    ;(this.mobile = ''), (this.password = '')
  }
}

</script>

<style scoped>
.loginMain_he {
  margin-top: 3rem;
}
.userLoginTitle_he {
  margin-left: 0;
}
.van-cell,
.van-cell-group {
  background: none;
}
.van-cell {
  background: none;
  font-size: 0.373333rem;
}
.van-icon-eye-o::before {
  color: #6d7174;
}
.van-cell::after {
  border: none;
}
.van-cell {
  border-bottom: 0.026667rem solid #dfdede;
  margin-bottom: 0.72rem;
}
[class*='van-hairline']::after {
  border: none;
}
.van-field {
  padding: 0.213333rem 0 0.213333rem 0;
}
.mobileLgWrap_he img {
  width: 6.16rem;
  height: 1.28rem;
}
.blue {
  color: #2e56d5;
}
</style>


// WEBPACK FOOTER //
// MobileLogin.vue?b1269d26